import { z } from "zod";
import { isoDateTimeString, uuidSchema } from "./common";

export const blacklistEntrySchema = z.object({
  id: uuidSchema,
  orgId: uuidSchema,
  orgName: z.string(),
  reason: z.string().nullable().optional(),
  createdAt: isoDateTimeString,
});

export const addBlacklistRequestSchema = z.object({
  orgId: uuidSchema,
  reason: z.string().max(500).optional(),
});

export const blacklistListResponseSchema = z.object({
  items: z.array(blacklistEntrySchema),
});

export type BlacklistEntry = z.infer<typeof blacklistEntrySchema>;
export type AddBlacklistRequest = z.infer<typeof addBlacklistRequestSchema>;
export type BlacklistListResponse = z.infer<typeof blacklistListResponseSchema>;
